/**
 * Interface for communicating with Extractor service.
 *
 * @unstable
 */

// TODO: Change colorservice to cloudfunction

import { Injectable } from '@angular/core';
import { Commands } from '@shared/enums/commands.enum';
import { Observable, of } from 'rxjs';
import { ExtractorData } from '@editor/shared/models/extractor.model';
import { catchError } from 'rxjs/operators';
import { CloudFunctions } from './cloud-functions.service';

@Injectable({
  providedIn: 'root',
})
export class ExtractorApi {
  constructor(private cf: CloudFunctions) {}

  extract(url: string, type: 'design' | 'text' = 'design', extractColors?: boolean): Observable<ExtractorData | null> {
    return this.cf
      .get(Commands.ExtractDesign, type, { url, ...(extractColors ? { extractColors: 'true' } : {}) })
      .pipe(catchError(() => of(null)));
  }

  backgroundImages(response: ExtractorData) {
    const ok = Boolean(response && response.assets);
    const logos = response.assets.images.filter((image) => image.includes('logo'));
    const other = response.assets.images.filter((image) => !image.includes('logo'));

    return !ok ? [] : other.concat(...logos);
  }

  logoImages(response: ExtractorData) {
    const ok = Boolean(response && response.assets);
    const logos = response.assets.images.filter((image) => image.includes('logo'));
    const other = response.assets.images.filter((image) => !image.includes('logo'));

    return !ok ? [] : logos.concat(...other);
  }

  images(response: ExtractorData) {
    const ok = Boolean(response && response.assets);

    return !ok ? [] : response.assets.images;
  }

  fonts(response: ExtractorData) {
    const ok = Boolean(response && response.assets);

    return !ok ? [] : response.assets.fonts.filter((font) => !font.includes('icon'));
  }

  colors(response: ExtractorData, filterOpacity?: boolean) {
    const ok = Boolean(response && response.assets);

    let colors = !ok ? [] : response.assets.colors.slice(0, 19);

    if (filterOpacity) {
      colors = colors.map((color) => color.slice(0, 7));
    }

    return colors;
  }
}
